import(/* webpackMode: "eager" */ "/vercel/path0/src/app/progress/page.tsx");
